const template = require('./portfolios_edit.html.slim');
declare var angular
import { values, groupBy, sumBy, every, remove, union, find } from 'lodash'

export class PortfolioEdit {
  static $inject = [
    '$routeParams', '$location', 'PortfolioModels', 'Portfolios', 'Holding'
  ]

  portfolioModels;
  portfolio;
  newHolding;
  allocationTotal: number = 0;
  loaded: boolean = false;

  constructor(
    private $routeParams, private $location,
    private PortfolioModel, private Portfolio, private Holding
  ) {
    this.portfolioModels = PortfolioModel.query();
    if ($routeParams.id) {
      Portfolio.get({ id: $routeParams.id }).$promise
        .then( (p) => {
          this.portfolio = p
          this.loaded = true
          this.updateAssetAllocation()
        })
    } else {
      this.portfolio = {
        holdings: [],
        portfolioModelId: +$routeParams.modelId,
      }
      this.loaded = true
      this.updateAssetAllocation()
    }
  }

  searchHoldings(query) {
    return this.Holding.query({ search: query }).$promise
  }

  addHolding(item, model, label) {
    if (find(this.portfolio.holdings, item)) return;
    item.allocation = 1 - this.allocationTotal
    this.portfolio.holdings = union(this.portfolio.holdings, [item]);
    this.updateAssetAllocation()
    return this.newHolding = null;
  }

  removeHolding(holding) {
    remove(this.portfolio.holdings, { id: holding.id })
    let remainingAllocation = 1 - holding.allocation;
    let totalAllocation = 0;
    this.portfolio.holdings.forEach(function(holding) {
      holding.allocation /= remainingAllocation;
      holding.allocation = Number(holding.allocation.toFixed(3));
      totalAllocation += holding.allocation;
    })
    if (totalAllocation !== 1) {
      return this.portfolio.holdings[0].allocation += 1 - totalAllocation
    }
    this.updateAssetAllocation()
  }

  get allocationTotalValid() { return Math.abs(this.allocationTotal - 1) < 0.001 }

  save() {
    if (this.portfolio.id) {
      this.portfolio.$update((p) => {
        this.$location.path(this.showPath())
      })
    } else {
      this.Portfolio.create(this.portfolio, (p) => {
        this.$location.path(this.showPath(p.id))
      })
    }
  }

  delete() {
    if (confirm(`Are you sure you wish to delete portfolio: ${this.portfolio.name}?`)) {
      this.portfolio.$delete( () => {
        this.$location.path(this.listPath())
      })
    }
  }

  listPath() {
    return 'portfolio-models';
  }

  showPath(id = null) {
    id = id || this.portfolio.id
    if (id) return `portfolios/${id}`
  }

  private updateAssetAllocation() {
    let groupedByAssetClass = groupBy(this.portfolio.holdings, 'assetClass')
    let assetAllocation = values(groupedByAssetClass).map(function(x: any) {
      return {
        assetClass: x[0].assetClass,
        allocation: sumBy(x, 'allocation')
      }
    })
    this.allocationTotal = sumBy(assetAllocation, 'allocation')
  }
}

angular.module('wbComponents').directive('portfoliosEdit', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: template,
    controller: PortfolioEdit,
    controllerAs: 'ctrl',
  }
})
